// extracted by mini-css-extract-plugin
export default {"dropZone":"DropZone_dropZone__mYn+9"};